import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { ExternalLink, Download, ArrowRight, BarChart4, Shield } from 'lucide-react';

const OptOutScreen = ({ onFullApp, onDownloadApp }) => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="text-center space-y-4">
        <h1 className="text-2xl font-bold text-gray-900">No Problem</h1>
        <p className="text-gray-600">
          Thanks for creating your Ownli Insurance Profile
        </p>
      </div>
      
      {/* Info Card */}
      <Card className="bg-blue-50 border-blue-100">
        <CardContent className="pt-6">
          <div className="flex items-start gap-3">
            <Shield className="w-5 h-5 text-blue-500 mt-1" />
            <div>
              <p className="font-medium text-blue-900">Your Privacy Matters</p>
              <p className="text-sm text-blue-700">
                We respect your decision not to share contact information at this time. 
                You can still access all Ownli features.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
      
      {/* Options Card */}
      <Card>
        <CardHeader>
          <CardTitle>What would you like to do next?</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          {/* Full App Option */}
          <button
            onClick={onFullApp}
            className="w-full flex items-center justify-between p-4 rounded-lg border border-gray-200 hover:border-blue-300 hover:bg-blue-50 transition-colors"
          >
            <div className="flex items-center gap-3">
              <BarChart4 className="w-5 h-5 text-blue-500" />
              <div className="text-left">
                <p className="font-medium text-gray-900">Go to Ownli.</p>
                <p className="text-sm text-gray-600">Access Ownli features on the web</p>
              </div>
            </div>
            <ArrowRight className="w-4 h-4 text-gray-400" />
          </button>
          
          {/* Download App Option */}
          <button
            onClick={onDownloadApp}
            className="w-full flex items-center justify-between p-4 rounded-lg border border-gray-200 hover:border-blue-300 hover:bg-blue-50 transition-colors"
          >
            <div className="flex items-center gap-3">
              <Download className="w-5 h-5 text-blue-500" />
              <div className="text-left">
                <p className="font-medium text-gray-900">Download Mobile App</p>
                <p className="text-sm text-gray-600">Get Ownli on your phone for more rewards</p>
              </div>
            </div>
            <ArrowRight className="w-4 h-4 text-gray-400" />
          </button>
        </CardContent>
      </Card>
      
      {/* Additional Info Card */}
      <Card>
        <CardContent className="pt-6">
          <h3 className="font-medium text-gray-900 mb-3">Why Use Ownli?</h3>
          <ul className="space-y-2 text-sm text-gray-600">
            <li className="flex items-start gap-2">
              <div className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="text-xs text-green-700">✓</span>
              </div>
              <span>Earn rewards for your data</span>
            </li>
            <li className="flex items-start gap-2">
              <div className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="text-xs text-green-700">✓</span>
              </div>
              <span>Maintain control over your personal information</span>
            </li>
            <li className="flex items-start gap-2">
              <div className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="text-xs text-green-700">✓</span>
              </div>
              <span>Get better offers from trusted partners</span>
            </li>
          </ul>
        </CardContent>
      </Card>
      
      {/* External Links */}
      <div className="flex justify-between">
        <button
          onClick={() =>
            window.open(
              "https://support.ownli.co/hc/en-us/articles/360011276138-Ownli-Privacy-Policy",
              "_blank"
            )
          }
          className="flex items-center gap-1 text-sm text-blue-600"
        >
          Privacy Policy
          <ExternalLink className="w-3 h-3" />
        </button>
        
        <a 
          href="mailto:contact@ownli.co" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-sm text-gray-500 hover:text-gray-700 flex items-center gap-1"
        >
          Contact Us
          <ExternalLink className="w-3 h-3" />
        </a>
      </div>
    </div>
  );
};

export default OptOutScreen;